import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      localStorage.setItem("admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0c] text-[#f4f4f6] flex items-center justify-center px-5" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }} className="w-full max-w-sm">
        <Link to="/" className="block mb-10" data-testid="login-logo">
          <img src="/logo.png" alt="Strength Syndicate" className="h-32 w-auto mx-auto" />
        </Link>
        <form onSubmit={submit} className="border border-white/10 bg-[#121216] p-8" data-testid="login-form">
          <div className="flex items-center gap-3 mb-8">
            <Lock size={16} className="text-[#ccff00]" />
            <h1 className="font-mono-alt text-xs tracking-[0.3em] uppercase text-zinc-400">Coach Access</h1>
          </div>
          <label className="block font-mono-alt text-[11px] tracking-[0.25em] uppercase text-zinc-500 mb-2.5">Email</label>
          <input
            type="email"
            required
            data-testid="login-email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-[#0d0d10] border border-white/10 focus:border-[#ccff00] outline-none px-4 py-3.5 text-base text-white mb-6 transition-colors"
            placeholder="admin@nimish.co"
          />
          <label className="block font-mono-alt text-[11px] tracking-[0.25em] uppercase text-zinc-500 mb-2.5">Password</label>
          <input
            type="password"
            required
            data-testid="login-password-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-[#0d0d10] border border-white/10 focus:border-[#ccff00] outline-none px-4 py-3.5 text-base text-white mb-8 transition-colors"
            placeholder="••••••••"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full flex items-center justify-center gap-2 bg-[#ccff00] hover:bg-[#a8d600] disabled:opacity-50 text-black font-mono-alt text-xs tracking-[0.2em] uppercase py-4 transition-colors"
          >
            {loading && <Loader2 size={14} className="animate-spin" />}
            Sign in
          </button>
        </form>
      </motion.div>
    </div>
  );
}
